import { isClient } from "./envs";

export async function generateKey() {
  if (!isClient()) return null;

  return await window.crypto.subtle.generateKey(
    {
      name: "RSA-OAEP",
      modulusLength: 4096,
      publicExponent: new Uint8Array([1, 0, 1]),
      hash: "SHA-256",
    },
    true,
    ["encrypt", "decrypt"]
  );
}

export async function importKey(key: any) {
  if (!isClient()) return null;

  return await window.crypto.subtle.importKey("raw", key, "AES-CBC", true, [
    "encrypt",
    "decrypt",
  ]);
}

export async function exportPublicKey(key: any) {
  if (!isClient()) return null;

  const exported = await window.crypto.subtle.exportKey("spki", key);
  const exportedAsString = arrayBufferToString(exported);
  return window.btoa(exportedAsString!);
}

export async function decryptRasOaep(key: CryptoKey, decryptedData: any) {
  if (!isClient()) return null;

  const binaryDerString = window.atob(decryptedData);
  const arrayBuffer = stringToArrayBuffer(binaryDerString);
  return await window.crypto.subtle.decrypt(
    { name: "RSA-OAEP" },
    key,
    arrayBuffer!
  );
}

export async function decryptAesCbc(key: any, encryptedData: any) {
  if (!isClient()) return null;

  let encryptedDataArray = Uint8Array.from(atob(encryptedData), (c) =>
    c.charCodeAt(0)
  );
  let iv = encryptedDataArray.slice(0, 16);
  let data = encryptedDataArray.slice(16);
  let decryptedData = await crypto.subtle.decrypt(
    { name: "AES-CBC", iv },
    key,
    data
  );
  return new TextDecoder().decode(decryptedData);
}

function stringToArrayBuffer(str: string) {
  if (!isClient()) return null;

  const buf = new ArrayBuffer(str.length);
  const bufView = new Uint8Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

function arrayBufferToString(buf: any) {
  if (!isClient()) return null;

  return String.fromCharCode.apply(null, new Uint8Array(buf) as any);
}
